// Libs
import classNames from 'classnames/bind';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form';
// Components, Layouts, Pages
import { BaseLabel, BaseSelectFileModal, ItemFileAttachment, UnderDevelopment } from '~/components/common';
// Others
import { IFormQuotes } from '~/utils/interface/quotes';
import { IBaseFile } from '~/utils/interface/common';
// Styles, images, icons
import styles from './AttachmentsQuoteForm.module.scss';
import { icons } from '~/assets';

type Props = {
  onRemoveFile?: (id: string) => void;
};

const cx = classNames.bind(styles);

const AttachmentsQuoteForm = (props: Props) => {
  //#region Destructuring Props
  const { onRemoveFile } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/quotes', 'common/base']);

  const { control, watch } = useFormContext<IFormQuotes>();

  const { append: appendQuoteFiles, remove: removeQuoteFiles } = useFieldArray({
    control,
    name: 'quoteFile',
  });

  const filesQuote = watch('quoteFile');
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [showAddFileModal, setShowAddFileModal] = useState<boolean>(false);
  const [showUnderDevelopment, setShowUnderDevelopment] = useState<boolean>(false);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleShowAddFileModal = () => {
    setShowAddFileModal(!showAddFileModal);
  };

  const handleAddFile = (files: IBaseFile[]) => {
    if (!files) return;

    files.map((item) => appendQuoteFiles(item));
  };

  const handleShowUnderDevelopment = () => {
    setShowUnderDevelopment(!showUnderDevelopment);
  };

  const handleRemoveFile = (file: IBaseFile, index?: number) => {
    if (!file.id) return;
    onRemoveFile?.(file.id);

    removeQuoteFiles(index);
  };
  //#endregion Handle Function

  return (
    <Box id='attachmentsQuoteFormComponent' className={cx('container')}>
      <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
        <BaseLabel icon={icons.commonIconAttachments} styleType='title' label={t('form_quotes_title_attachments')} />

        <Button
          variant='outlined'
          className={cx('buttonAddFile')}
          startIcon={<img src={icons.commonIconPlusPrimary} alt={t('common_alt_img')} />}
          onClick={handleShowAddFileModal}
        >
          {t('form_quotes_button_add_file')}
        </Button>
      </Stack>

      <Stack direction={'column'} gap={4}>
        {filesQuote &&
          filesQuote.length > 0 &&
          filesQuote.map((item, index) => (
            <ItemFileAttachment key={index} file={item} index={index} onRemoveFile={handleRemoveFile} />
          ))}
      </Stack>

      {showAddFileModal && <BaseSelectFileModal onAdd={handleAddFile} onClose={handleShowAddFileModal} />}

      {showUnderDevelopment && <UnderDevelopment onClose={handleShowUnderDevelopment} />}
    </Box>
  );
};

export default AttachmentsQuoteForm;
